import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurcabs() {



const cardData = {
  keyword: " Pune to Kolhapur Cabs  ",

"headingDescription": "Pune to Kolhapur Cabs service is ideal for travelers seeking a smooth and comfortable intercity journey between Pune and Kolhapur. SRS Cab Service focuses on delivering a relaxed travel experience with well-maintained vehicles, skilled drivers, and flexible scheduling options. Whether you are planning a religious visit, family trip, or business travel, our cab service ensures convenience from pickup to drop. With easy booking, reliable support, and transparent fare structure, your Pune to Kolhapur journey becomes efficient and enjoyable.",
"topPlaces": [
  {
    "title": "Mahalaxmi Temple Kolhapur",
    "description": "Mahalaxmi Temple is one of the most famous temples in Maharashtra dedicated to Goddess Mahalaxmi. Travelers booking Pune to Kolhapur Cabs visit this sacred site to seek blessings and experience spiritual peace."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a scenic spot in Kolhapur known for its calm waters and relaxing environment. Visitors using Pune to Kolhapur Cabs enjoy spending time here with beautiful sunset views."
  },
  {
    "title": "New Palace (Kolhapur)",
    "description": "The New Palace in Kolhapur showcases royal architecture and houses a museum of historical artifacts. Travelers using Pune to Kolhapur Cabs explore this palace to learn about the city’s heritage."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is a historic hill fort offering panoramic views and rich history. Visitors booking Pune to Kolhapur Cabs often visit this fort for sightseeing and trekking."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Jyotiba Temple is a popular pilgrimage site located on a hill near Kolhapur. Travelers using Pune to Kolhapur Cabs visit this temple for its spiritual importance and scenic surroundings."
  },
  {
    "title": "Radhanagari Dam",
    "description": "Radhanagari Dam is a peaceful destination surrounded by greenery and wildlife. Visitors using Pune to Kolhapur Cabs enjoy nature and relaxation at this scenic spot."
  },
  {
    "title": "Town Hall Museum",
    "description": "Town Hall Museum in Kolhapur displays artifacts from the region’s history and culture. Travelers using Pune to Kolhapur Cabs explore this museum to understand local traditions."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Dajipur Wildlife Sanctuary is known for its rich biodiversity and forest landscapes. Visitors booking Pune to Kolhapur Cabs enjoy wildlife exploration and nature trails here."
  },
  {
    "title": "Binkhambi Ganesh Temple",
    "description": "Binkhambi Ganesh Temple is a unique temple built without pillars, dedicated to Lord Ganesha. Travelers using Pune to Kolhapur Cabs visit this place for its architectural uniqueness."
  },
  {
    "title": "Chandrakant Mandare Museum",
    "description": "Chandrakant Mandare Museum showcases paintings and artwork by the famous Marathi artist. Visitors using Pune to Kolhapur Cabs explore this place for its artistic and cultural value."
  }
],



services: [
{
name: "Pune to Kolhapur Cab",
description: "Pune to Kolhapur cab offers reliable intercity travel for business and pilgrimage trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily from Pune to Kolhapur with cab services."
},
{
name: "Pune to Kolhapur Cab Service",
description: "Pune to Kolhapur cab service provides dependable transportation for long-distance travel. Customers can book cabs for family and corporate trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Choose cab services for Pune to Kolhapur travel."
},
{
name: "Pune to Kolhapur Car Rental",
description: "Pune to Kolhapur car rental offers flexible vehicle options for travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Kolhapur easily."
},
{
name: "One Way Cab from Pune to Kolhapur",
description: "One way cab from Pune to Kolhapur offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Kolhapur travel."
},
{
name: "Pune Airport to Kolhapur Cab",
description: "Pune airport to Kolhapur cab offers direct travel from airport to destination. Customers can book cabs for convenient transfers. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune Airport to Kolhapur."
},
{
name: "Pune Kolhapur Cab Service",
description: "Pune Kolhapur cab service provides reliable transportation between two cities. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Pune Kolhapur cab services."
},
{
name: "Pune to Kolhapur by Car",
description: "Pune to Kolhapur by car offers comfortable road travel for long journeys. Customers can enjoy scenic highway routes. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel conveniently from Pune to Kolhapur by car."
},
{
name: "Pune to Kolhapur Cab Booking",
description: "Pune to Kolhapur cab booking provides quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Kolhapur cab easily."
},
{
name: "Pune to Kolhapur Cab Price",
description: "Pune to Kolhapur cab price offers detailed pricing for travelers. Customers can compare rates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Kolhapur Car Hire",
description: "Pune to Kolhapur car hire offers flexible travel solutions with driver options. Customers can hire vehicles for long-distance trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cars from Pune to Kolhapur easily."
},
{
name: "Pune to Kolhapur One Way Cab",
description: "Pune to Kolhapur one way cab provides cost-effective travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Kolhapur."
},
{
name: "Pune to Kolhapur Taxi Charges",
description: "Pune to Kolhapur taxi charges provide clear pricing details for travelers. Customers can check charges before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent charges."
},
{
name: "Pune to Admapur Cab Service",
description: "Pune to Admapur cab service offers convenient travel to religious destinations. Customers can visit Balumama temple easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Admapur."
},
{
name: "Pune to Admapur Balumama Cabs",
description: "Pune to Admapur Balumama cabs provide reliable transportation for pilgrimage trips. Customers can book cabs for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Balumama cab services."
},
{
name: "Pune to Jyotirlinga Darshan Cab Service",
description: "Pune to Jyotirlinga darshan cab service offers spiritual travel for devotees. Customers can visit multiple temples comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Jyotirlinga cab services."
},
{
name: "Pune to Mahalaxmi Temple Kolhapur Taxi Service",
description: "Pune to Mahalaxmi temple Kolhapur taxi service provides direct travel for devotees. Customers can visit the famous temple comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Kolhapur temple."
},
{
name: "Pune to Sade Teen Shakti Peeth Cab Package",
description: "Pune to Sade Teen Shakti Peeth cab package offers organized pilgrimage travel. Customers can visit all sacred temples easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book Shakti Peeth cab packages from Pune."
},
{
name: "Pune to Kolhapur Taxi",
description: "Pune to Kolhapur taxi service provides convenient transportation for travelers. Customers can book taxis for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Kolhapur Taxi Service",
description: "Pune to Kolhapur taxi service offers dependable travel options for passengers. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services from Pune."
},
{
name: "Pune to Kolhapur Taxi Booking",
description: "Pune to Kolhapur taxi booking offers easy reservation options for travelers. Customers can book taxis online instantly. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune to Kolhapur."
},
{
name: "Pune to Kolhapur One Way Taxi",
description: "Pune to Kolhapur one way taxi offers cost-effective travel for direct journeys. Customers can book taxis easily without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way taxi services."
},
{
name: "Pune to Kolhapur Cab Fare",
description: "Pune to Kolhapur cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Kolhapur Taxi Price",
description: "Pune to Kolhapur taxi price provides clear pricing for travelers. Customers can check price details before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
},
{
name: "Pune to Kolhapur Cab Hire",
description: "Pune to Kolhapur cab hire offers flexible travel solutions for long-distance trips. Customers can hire vehicles for personal or business travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cabs from Pune to Kolhapur easily."
},
{
name: "Pune to Kolhapur Taxi Hire",
description: "Pune to Kolhapur taxi hire provides convenient transportation for travelers. Customers can hire taxis for flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose taxi hire services for Pune to Kolhapur travel."
},
{
name: "Pune to Kolhapur Outstation Cab",
description: "Pune to Kolhapur outstation cab offers reliable travel for long-distance trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
}
],

tableData: [
["Pune to Kolhapur Cab","Pune to Kolhapur Cab Service"],
["Pune to Kolhapur Car Rental","One Way Cab from Pune to Kolhapur"],
["Pune Airport to Kolhapur Cab","Pune Kolhapur Cab Service"],
["Pune to Kolhapur by Car","Pune to Kolhapur Cab Booking"],
["Pune to Kolhapur Cab Price","Pune to Kolhapur Car Hire"],
["Pune to Kolhapur One Way Cab","Pune to Kolhapur Taxi Charges"],
["Pune to Admapur Cab Service","Pune to Admapur Balumama Cabs"],
["Pune to Jyotirlinga Darshan Cab Service","Pune to Mahalaxmi Temple Kolhapur Taxi Service"],
["Pune to Sade Teen Shakti Peeth Cab Package","Pune to Kolhapur Taxi"],
["Pune to Kolhapur Taxi Service","Pune to Kolhapur Taxi Booking"],
["Pune to Kolhapur One Way Taxi","Pune to Kolhapur Cab Fare"],
["Pune to Kolhapur Taxi Price","Pune to Kolhapur Cab Hire"],
["Pune to Kolhapur Taxi Hire","Pune to Kolhapur Outstation Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers experienced in Pune to Kolhapur highway routes, ensuring safe driving, smooth travel, and timely arrival."
  },
  {
    WhyChooseheading: "Affordable Pune to Kolhapur Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Kolhapur cab services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Kolhapur cab bookings, making it convenient for business trips, family travel, and religious journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles to ensure a comfortable journey from Pune to Kolhapur."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Kolhapur journeys."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Kolhapur cab bookings due to punctual drivers, reliable vehicles, and professional service."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Kolhapur cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Kolhapur." },
  { question: "How far is Kolhapur from Pune?", answer: "The distance between Pune and Kolhapur is approximately 230 km and the journey takes around 4 to 5 hours." },
  { question: "Is Pune to Kolhapur cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Kolhapur travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Kolhapur?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Kolhapur cab service online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." },
  { question: "Do you provide round trip packages?", answer: "Yes, we offer affordable round-trip cab packages for Pune to Kolhapur travel." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Patil",
    feedback:
      "Booked SRS Cab Service for Pune to Kolhapur trip. Smooth journey and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Kavita Desai",
    feedback:
      "Reliable Pune to Kolhapur cab service. Clean car and comfortable ride.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kolhapur Cabs | SRS Cab",
  "description": "SRS Cab provides Pune to Kolhapur cab services including one-way and round trips, airport transfers, car rentals, and taxi bookings. Travel safely and comfortably to Kolhapur, Mahalaxmi Temple, Jyotirlinga Darshan, Admapur, and Sade Teen Shakti Peeth with affordable fares and 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Kolhapur Cabs | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Kolhapur cabs with SRS Cab. One-way, round trips, airport transfers, car rentals, and taxi bookings from Pune to Kolhapur, Mahalaxmi Temple, Jyotirlinga Darshan, Admapur, and Sade Teen Shakti Peeth. Safe, comfortable rides with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokolhapurcabs;